function parseErrorBadRequest(): string {
  return 'Произошла ошибка, пожалуйста обратить в саппорт!';
}

export default parseErrorBadRequest;
